export default defineNuxtPlugin((nuxtApp) => {
  // To initialy set the session token for "the other" GraphQL Client
  const session = useSession(); // Session composable

  if (session.hasSession()) {
    useGqlHeaders({ "X-Parse-Session-Token": session.session.value });
  }
});
